import { Toaster as Sonner } from '@/components/ui/sonner';
import { Toaster } from '@/components/ui/toaster';
import { toast } from 'sonner';
import { useToast } from '../ui/use-toast';
import { sonnerLoading, sonnerLoadingV2 } from './custom-sonner';
import { sonnerWithTemplate } from './sonner-with-template';

const CustomToast = {
    /**default sonner */
    sonner: toast,

    sonnerV2: sonnerWithTemplate,

    /**custom-loading sonner without close button */
    sonnerLoading: sonnerLoading,

    /**custom-loading sonner without close button and dismiss function */
    sonnerLoadingV2: sonnerLoadingV2,

    /**SonnerContainer */
    SonnerContainer: Sonner,

    /**ToasterContainer */
    ToasterContainer: Toaster,

    /**useToast */
    useToast: useToast,
};

export default CustomToast;
